

export const DigitalStepMap = [
  {
    name: "greeting_card",
    values: ["properties._gcp_selected_card_image"]
  },
  {
    name: "gift_card",
    values: [
      "id",
      "properties._gcp_custom_value",
      "properties._gcp_send_to_self",
      "properties._gcp_recipient_email",
      "properties._gcp_recipient_phone",
      "properties._gcp_recipient_name",
      "properties._gcp_delivery_time",
      "properties._gcp_delivery_date",
      "properties._gcp_delivery_timezone"
    ]
  },
  {
    name: "gift_message",
    values: [
      "properties._gcp_message_from",
      "properties._gcp_message_text",
      "properties._gcp_message_salutation",
      "properties._gcp_message_font_family",
      "properties._gcp_signature_font_family"
    ]
  }
];

export const PhysicalStepMap = [
  {
    name: "greeting_card",
    values: ["properties._gcp_selected_card_image"]
  },
  {
    name: "gift_card",
    values: [
      "id",
      "properties._gcp_custom_value",
      "properties._gcp_address.firstName",
      "properties._gcp_address.lastName",
      "properties._gcp_address.address1",
      "properties._gcp_address.address2",
      "properties._gcp_address.city",
      "properties._gcp_address.country",
      "properties._gcp_address.province",
      "properties._gcp_address.zip",
      "properties._gcp_address.phone",
      "properties._gcp_delivery_time",
      "properties._gcp_delivery_date",
      "properties._gcp_delivery_timezone"
    ]
  },
  {
    name: "gift_message",
    values: [
      "properties._gcp_message_from",
      "properties._gcp_message_text",
      "properties._gcp_message_salutation",
      "properties._gcp_message_font_family",
      "properties._gcp_signature_font_family"
    ]
  }
];



